'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FactboxFooter = function FactboxFooter(_ref) {
    var isExpanded = _ref.isExpanded,
        onToggleExpanded = _ref.onToggleExpanded,
        theme = _ref.theme,
        contentId = _ref.contentId,
        i18n = _ref.i18n,
        attributes = _ref.attributes;
    return _react2.default.createElement(
        'footer',
        { className: theme.footer },
        _react2.default.createElement(
            'button',
            (0, _extends3.default)({}, attributes({ elementName: 'factboxFooterButton' }), {
                className: theme.button,
                type: 'button',
                onClick: onToggleExpanded,
                'aria-expanded': isExpanded,
                'aria-controls': contentId
            }),
            isExpanded ? i18n.readLess : i18n.readMore
        )
    );
};

FactboxFooter.propTypes = {
    attributes: _propTypes2.default.func.isRequired,
    isExpanded: _propTypes2.default.bool.isRequired,
    onToggleExpanded: _propTypes2.default.func.isRequired,
    theme: _propTypes2.default.shape({
        footer: _propTypes2.default.string,
        button: _propTypes2.default.string
    }).isRequired,
    contentId: _propTypes2.default.string,
    i18n: _propTypes2.default.shape({
        heading: _propTypes2.default.string,
        readMore: _propTypes2.default.string,
        readLess: _propTypes2.default.string
    }).isRequired
};

FactboxFooter.defaultProps = {
    attributes: function attributes() {
        return {};
    },
    isExpanded: false,
    contentId: ''
};

exports.default = FactboxFooter;
//# sourceMappingURL=FactboxFooter.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/FactboxFooter/FactboxFooter.js
 ** module id = 512
 ** module chunks = 1
 **/